import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormDialogTemplate } from '../form-dialog/form-dialog.template';

@Injectable()
export class PanelbarService {

    formDialog: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private readonly dialogStack: FormDialogTemplate[] = [];

    expanded: any[] = [];

    constructor() { }

    openDialog(template: FormDialogTemplate) {
        if (template) this.dialogStack.push(template);
        this.formDialog.next(template);
    }

    closeDialog() {
        this.dialogStack.pop();
        this.openDialog(this.dialogStack.pop());
    }

    addExpandPanelbar(id: string) {
        if (!this.expanded.some(x => x === id)) this.expanded.push(id);
    }


    removeExpandPanelbar(id: string) {
        const index = this.expanded.indexOf(this.expanded.find(x => x === id));
        if (index > -1) this.expanded.splice(index, 1);
    }


}

export enum ApprovalStatus {
    ACCEPTED = "Accepted",
    APPROVED = "Approved",
    APPROVED_WIP = "Approved - WIP",
    APPROVED_DES_REJECT = "Approved - Designer Rejected",
    CANCELLED = "Cancelled",
    COMPLETE = "Complete",
    DES_COMPLETE = "DES Complete",
    FINISHED = "Finished",
    REJECTED = "Rejected",
    REJECT = "Reject",
    REWORK = "Rework",
    REWORK_REQUESTED = "Rework Requested",
    PENDING = "Pending",
    WAIVED = "Waived",
    ONHOLD = "OnHold",
}
